export default __webpack_public_path__ + "07208d088de1d5a06df6f1bcede58d66.svg";